import Button from "shared/Button";
import FormInput from "../../../shared/FormInputs"
import * as Yup from "yup";
import { useFormik } from "formik";
import { CategoryTableData, useInventory } from "../modal/InventoryContext";
import { useNavigate } from "react-router-dom";
import SuccessfullModal from "shared/SuccessfullModal";


const formSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    description: Yup.string().required("Description is Required")
});

const CategoryForm = () => {
    const navigate = useNavigate()
    const { addCategory, successfullModal, setSuccessfullModal, setEditingCategory, editingCategory, updateCategory } = useInventory();

    const labelStyles = "font-urbanist font-semibold text-base md:text-lg lg:text-[21px] lg:leading-[180%] text-foreground"
    const inputBorder = "inputMainBorder mt-3.5 w-full rounded-[8px]"
    const inputStyles = "inputBox text-sm md:text-base leading-normal px-4 py-2.5 lg:py-[21px] lg:px-[29px] rounded-[15px] text-foreground placeholder-muted-foreground"
    const errorClasses = "text-red-500 text-xs mt-1 absolute -bottom-6"

    const handleSubmit = (values: any) => {
        console.log(editingCategory)
        if (editingCategory !== null && updateCategory) {
            const updatedStore = {
                ...editingCategory,
                ...values,
            };
            updateCategory(updatedStore);
            formik.resetForm();
        } else {
            const newStore: CategoryTableData = {
                categoryName: values.name,
                categoryDescription: values.description
            }
            const added = addCategory(newStore);
            console.log(added)
            if (added) {
                formik.resetForm();
            }
        }
    }

    const formik = useFormik({
        initialValues: {
            name: editingCategory?.categoryName,
            description: editingCategory?.categoryDescription
        },
        validationSchema: formSchema,
        onSubmit: handleSubmit,
        enableReinitialize: true,
    });
    const successfullyAdded = () => {
        setEditingCategory(null)
        setSuccessfullModal(false)
        navigate('/admin/inventory/categories')
        window.scrollTo(0, 0);
        document.body.style.overflow = "auto"
    }
    console.log(editingCategory, "editing store")

    return (
        <>
            <form onSubmit={formik.handleSubmit} noValidate>
                <div className="grid md:grid-cols-2 gap-3 md:gap-5 lg:gap-[38px]">
                    <div className="relative">
                        <FormInput label="Name" name="name" type="text" placeholder="Name" value={formik.values.name} onChange={formik.handleChange} labelClassName={`${labelStyles}`} inputMainBorder={`${inputBorder}`} inputClassName={`${inputStyles}`} />
                        {formik.errors.name && formik.touched.name && (
                            <p className={`${errorClasses}`}>
                                {formik.errors.name}
                            </p>
                        )}
                    </div>
                    <div className="relative">
                        <label className={`${labelStyles}`}>Description</label>
                        <div className={`${inputBorder} h-[76%]`}>
                            <textarea
                                className={`${inputStyles} w-full h-[181px] outline-none`}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                name="description"
                            />
                        </div>
                        {formik.errors.description && formik.touched.description && (
                            <p className={`${errorClasses}`}>
                                {formik.errors.description}
                            </p>
                        )}
                    </div>
                </div>

                <Button type="submit" disabled={editingCategory ? !formik.dirty : false} buttonClasses={`min-h-10 lg:min-h-[64px] border border-border border-solid bg-primary py-3 px-2 lg:py-5 lg:px-[75px] rounded-[15px] flex mx-auto lg:mx-0 mt-4 md:mt-[58px] text-base md:text-lg lg:text-2xl font-semibold lg:leading-[160%] font-urbanist text-primary-foreground min-w-[200px] lg:min-w-auto w-fit ${editingCategory && !formik.dirty ? 'opacity-50 !cursor-not-allowed' : 'opacity-1 !cursor-pointer'}`}>
                    {editingCategory ? 'Update' : 'Register'}
                </Button>
            </form>
            {successfullModal &&
                <SuccessfullModal modalClassName="" modalMain="" successfullOk={successfullyAdded}>
                    {editingCategory ? 'Successfully Updated your Category.' : 'Successfully Registered your Category.'}
                </SuccessfullModal>
            }
        </>
    )
}
export default CategoryForm